<template>
  <div>
    <b-input-group>
      <b-form-input
        id="input_recruit_task"
        size="sm"
        :disabled="isDisabled"
        v-model="query"
        placeholder="Выберите заявку"
        autocomplete="off"
        @focus="onFocusIn"
        @blur="onFocusOut"
      />

      <b-input-group-append>
        <b-button size="sm" :disabled="isDisabled || !query" @click="onClear">
          <font-awesome-icon icon="times-circle"/>
        </b-button>
      </b-input-group-append>

      <b-list-group class="autocomplete-input-recruit-task" v-if="isFocus">
        <b-list-group-item v-for="(item, index) in filteredItems" :key="index" @mousedown="onClick(item)" button>
          <div class="text-small">#{{ item.id }}</div>
          <div class="text-secondary text-small">{{ item.location_vacancy_name }}</div>
        </b-list-group-item>
        <b-list-group-item v-if="filteredItems.length === 0 && query" disabled>
          <small>Ничего не найдено</small>
        </b-list-group-item>
      </b-list-group>
    </b-input-group>
  </div>
</template>

<script>
import recruitTasks from "../../network/recruitTasks";

export default {
  name: "RecruitTaskSelect",
  mixins: [ recruitTasks ],
  props: {
    isDisabled: Boolean,
    value: { type: Number, default: null },
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
    }
  },
  mounted() {
    this.getItems();
  },
  computed: {
    filteredItems() {
      if (!this.query) return this.items;

      const lowerQuery = this.query.toLowerCase();

      return this.items.filter(item => {
        return String(item.id).includes(lowerQuery) || item.location_vacancy_name.toLowerCase().includes(lowerQuery);
      });
    }
  },
  methods: {
    async getItems(query) {
      const data = {
        query: query,
        currentPage: 1,
        perPage: 400
      }

      const result = await this.getRecruitTasks(data);

      this.items = (result && result.data) ? result.data.items : [];
    },
    onFocusIn() {
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;
    },
    onClick(item) {
      this.query = item.id;
      this.$emit('onSelect', item.id);
    },
    onClear() {
      this.query = "";
      this.$emit('onSelect', 0);
      this.$emit('onClear');
    },
  },
  watch: {
    query: {
      handler(newValue) {
        if (newValue === "" && this.value) {
          this.$emit('onSelect', 0);
        }
      }
    },
    value: {
      handler(newValue) {
        if (newValue) {
          this.query = String(newValue);
        }
      }, immediate: true
    },
  }
}
</script>

<style>
.autocomplete-input-recruit-task {
  max-height: 250px;
  margin-top: 31px;
  min-width: 100%;
  overflow-y: auto;
  position: absolute;
  z-index: 1000;
}

.autocomplete-input-recruit-task .list-group-item {
  padding: 0.5rem 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Recruiting/RecruitTaskSelect.vue